export const TableRowTypes = {
  Task: 'task',
  TaskGroup: 'task-group',
} as const;
